import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=5cbda373"
import script from "./SupportForm.vue?vue&type=script&lang=js"
export * from "./SupportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbda373')) {
      api.createRecord('5cbda373', component.options)
    } else {
      api.reload('5cbda373', component.options)
    }
    module.hot.accept("./SupportForm.vue?vue&type=template&id=5cbda373", function () {
      api.rerender('5cbda373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/SupportForm.vue"
export default component.exports